import { render, staticRenderFns } from "./EditarTipoCita.vue?vue&type=template&id=6c3b1a08&"
import script from "./EditarTipoCita.vue?vue&type=script&lang=js&"
export * from "./EditarTipoCita.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/franciscoriquelme/Documents/Elipse.ia/Proyectos/elipse-citas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c3b1a08')) {
      api.createRecord('6c3b1a08', component.options)
    } else {
      api.reload('6c3b1a08', component.options)
    }
    module.hot.accept("./EditarTipoCita.vue?vue&type=template&id=6c3b1a08&", function () {
      api.rerender('6c3b1a08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Subconjuntos/EditarTipoCita.vue"
export default component.exports